import React, { useState } from 'react';
import { useAppState } from '../../context/AppStateProvider';
import { GitBranch, Plus, Trash2 } from 'lucide-react';

const STAGES = ['Research', 'Identified', 'Contacted', 'Conversation', 'Proposal', 'Won', 'Lost'];

const WorkspacePipeline = () => {
  const { leads, updateLead, deleteLead, setSelectedItem } = useAppState();

  const getLeadsByStage = (stage) => leads.filter(l => l.status === stage);

  return (
    <div className="workspace-container" data-testid="workspace-pipeline">
      <div className="workspace-header">
        <div className="workspace-header-left">
          <GitBranch className="workspace-icon" size={24} />
          <div>
            <h2 className="workspace-title">Pipeline</h2>
            <p className="workspace-subtitle">{leads.length} total leads</p>
          </div>
        </div>
      </div>

      <div className="pipeline-board">
        {STAGES.map(stage => {
          const stageLeads = getLeadsByStage(stage);
          return (
            <div key={stage} className="pipeline-column" data-testid={`pipeline-stage-${stage.toLowerCase()}`}>
              <div className="pipeline-column-header">
                <h3 className="pipeline-stage-title">{stage}</h3>
                <span className="pipeline-stage-count">{stageLeads.length}</span>
              </div>
              <div className="pipeline-cards">
                {stageLeads.length === 0 ? (
                  <div className="pipeline-empty">No leads</div>
                ) : (
                  stageLeads.map(lead => (
                    <div 
                      key={lead.id} 
                      className="pipeline-card"
                      data-testid={`lead-card-${lead.id}`}
                      onClick={() => setSelectedItem(lead)}
                    >
                      <div className="pipeline-card-header">
                        <h4 className="pipeline-card-title">{lead.businessName}</h4>
                        <button
                          className="pipeline-card-delete"
                          data-testid={`delete-lead-${lead.id}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteLead(lead.id);
                          }}
                        >
                          <Trash2 size={14} />
                        </button>
                      </div>
                      {lead.category && (
                        <div className="pipeline-card-category" data-testid={`lead-category-${lead.id}`}>
                          {lead.category}
                        </div>
                      )}
                      {lead.niche && (
                        <div className="pipeline-card-niche">{lead.niche}</div>
                      )}
                      <select
                        value={lead.status}
                        onChange={(e) => {
                          e.stopPropagation();
                          updateLead(lead.id, { status: e.target.value });
                        }}
                        className="pipeline-card-status"
                        data-testid={`lead-status-${lead.id}`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {STAGES.map(s => (
                          <option key={s} value={s}>{s}</option>
                        ))}
                      </select>
                    </div>
                  ))
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WorkspacePipeline;
